import React, { Component } from "react"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Snackbar from "@material-ui/core/Snackbar"
import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import * as constants from "../constants"

const styles = (theme) => ({
      paper: {
            marginTop: theme.spacing(1),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
      },
      form: {
            width: "100%", // Fix IE 11 issue.
            marginTop: theme.spacing(1),
            direction: "rtl",
            textAlign: "right",
      },
      labelfloat: {
            margin: "10px",
      },
      TxtField: {
            color: "red", // Fix IE 11 issue.
            //  marginRight: theme.spacing(10),
            //textAlign: 'right',
            direction: "rtl",
            textAlign: "right",
            ///    float: 'right',
            textAlignLast: "right",
      },
      TxtField1: {
            color: "green", // Fix IE 11 issue.
            //  marginRight: theme.spacing(10),
            direction: "rtl",
            textAlign: "right",
            width: "100%",
      },

      label: {
            direction: "rtl",
            width: "100%", // Fix IE 11 issue.
      },
      submit: {
            margin: theme.spacing(3, 0, 2),
      },
      large: {
            width: theme.spacing(15),
            height: theme.spacing(15),
      },
})

class EditProfile extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  oldpass: "",
                  newpass: "",
                  renewpass: "",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  temp: null,
                  employee: {
                        employee_deactive: "",
                        employee_email: "",
                        employee_family: "",
                        employee_gender: "",
                        employee_id: "",
                        employee_image: "",
                        employee_image_code: "",
                        employee_image_tumb: "",
                        picturesRequestReady: "",
                        loading: false,
                        percent: 0,
                  },
            }
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getAgentDetail(arr.data)
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getAgentDetail = (employee_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ employee: arr.data })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "getemployee")

            fd.append("employee_id", employee_id)
            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      onSelectPicRequest = (picture) => {
            console.log(picture)
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }
      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeEmail = (event) => {
            var temp = this.state.employee
            temp.employee_email = event.target.value
            this.setState({ employee: temp })
      }

      uploadPicDelivery = (event) => {
            const { picturesRequestReady } = this.state

            const { requestState } = this.props
            if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                  this.setState({
                        loading: true,
                        percent: 0,
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.handdleChangeProperty(arr.data["image_code"])
                                    self.setState({
                                          loading: false,
                                          percent: 0,
                                    })
                              } else if (arr.result === "error") {
                              }
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "uploadpic")
                  fd.append("image", picturesRequestReady)
                  fd.append("image_name", "تصویر کارمند")
                  fd.append("image_desc", "تصویر کارمند کد" + this.cookies.get("employee_id"))
                  fd.append("name", "")
                  xhttp.upload.addEventListener(
                        "progress",
                        function(evt) {
                              if (evt.lengthComputable) {
                                    var percentComplete = evt.loaded / evt.total
                                    self.setState({
                                          percent: percentComplete * 100,
                                    })
                              }
                        },
                        false
                  )
                  xhttp.open("POST", `${constants.BASE_URL}/image`)
                  xhttp.send(fd)
            } else {
                  console.log("aaaaaaaa")
                  this.handdleChangeProperty("")
            }
      }

      handdleChangeProperty = (image_code) => {
            const { employee } = this.state

            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getAgent()
                              self.getAgentDetail(self.cookies.get("employee_id"))
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "changeproperty")
            fd.append("employee_email", employee.employee_email)
            console.log(image_code)
            if (image_code !== "") {
                  fd.append("employee_image_code", image_code)
            }

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getAgent = () => {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  //************************************************************************************************
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.props.props.dispatch({
                                          type: "SETPROPEMPLOYEE",
                                          state: arr.data,
                                    })
                              } else if (arr.result === "error") {
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "getemployee")
                  fd.append("employee_id", this.cookies.get("employee_id"))

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
                  //************************************************************************************************
            }
      }

      render() {
            const { classes } = this.props
            const { employee, snackMode, snackstr, showSnack, redirect, percent, loading } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <Container>
                              <Container component="main" maxWidth="md">
                                    <div dir="rtl" className={classes.paper}>
                                          <Typography component="h1" variant="h5">
                                                مشخصات کارمند
                                          </Typography>

                                          <Avatar alt="Remy Sharp" src={employee.employee_image_tumb} className={classes.large} />

                                          <form className={classes.form} noValidate>
                                                <Grid container spacing={3}>
                                                      <Grid item xs={12} sm={6}>
                                                            <FloatingLabelInput
                                                                  placeholder="نام و نام خانوادگی "
                                                                  disabled={true}
                                                                  value={
                                                                        employee.employee_gender +
                                                                        " " +
                                                                        employee.employee_name +
                                                                        " " +
                                                                        employee.employee_family
                                                                  }
                                                            />
                                                      </Grid>

                                                      <Grid item xs={12} sm={6}>
                                                            <FloatingLabelInput
                                                                  placeholder="شماره همراه"
                                                                  disabled={true}
                                                                  value={employee.employee_mobile}
                                                            />
                                                      </Grid>
                                                      <Grid item xs={12}>
                                                            <Divider />
                                                      </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                      <Grid item xs={12} sm={6}>
                                                            <FloatingLabelInput
                                                                  placeholder="ایمیل "
                                                                  handleInputt={this.handleChangeEmail}
                                                                  value={employee.employee_email}
                                                            />
                                                      </Grid>

                                                      <Grid item xs={12} sm={6}>
                                                            <ImageUploader
                                                                  withIcon={true}
                                                                  buttonText="عکس را انتخاب نمایید"
                                                                  onChange={this.onSelectPicRequest}
                                                                  withPreview="true"
                                                                  singleImage="true"
                                                                  imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                  maxFileSize={5242880}
                                                            />
                                                      </Grid>

                                                      <Grid item xs={12}>
                                                            {loading && <LinearProgress variant="determinate" value={percent} />}
                                                      </Grid>

                                                      <Grid item xs={12}>
                                                            <Divider />
                                                      </Grid>
                                                </Grid>

                                                <div style={{ width: "100%" }}>
                                                      <Snackbar
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                                            onClose={this.handleClickcloseTasckBar}
                                                            open={showSnack}
                                                            autoHideDuration={10000}
                                                      >
                                                            <Alert severity={snackMode}>{snackstr}</Alert>
                                                      </Snackbar>

                                                      <Button
                                                            fullWidth
                                                            variant="contained"
                                                            color="primary"
                                                            className={classes.submit}
                                                            onClick={this.uploadPicDelivery}
                                                      >
                                                            تغییر مشخصات
                                                      </Button>
                                                      <Divider />
                                                </div>
                                          </form>
                                    </div>
                              </Container>
                        </Container>
                  )
            }
      }
}

export default withStyles(styles)(EditProfile)
